/**
 * Initializes acquireData object in WPD.
 */
function init(wpd, dataEntryVM) {
	wpd.acquireData = (function () {
		let dataset, axes;

		function load() {
			dataset = getActiveDataset();
			axes = getAxes();

			if (axes == null) {
				wpd.messagePopup.show(
					wpd.gettext("dataset-no-calibration"),
					wpd.gettext("calibrate-dataset"),
				);
			} else {
				wpd.graphicsWidget.removeTool();
				wpd.graphicsWidget.resetData();
				showSidebar();
				wpd.dataPointCounter.setCount();
				wpd.graphicsWidget.removeTool();
				wpd.graphicsWidget.setRepainter(
					new wpd.DataPointsRepainter(axes, dataset),
				);

				wpd.graphicsWidget.forceHandlerRepaint();
				wpd.dataPointCounter.setCount(dataset.getCount());
			}
		}

		function getActiveDataset() {
			return wpd.tree.getActiveDataset();
		}

		function getAxes() {
			return wpd.appData.getPlotData().getAxesForDataset(getActiveDataset());
		}

		function selectText(resolve, keydownHandler) {
			const tool = new wpd.TextSelectionTool(resolve, keydownHandler);
			tool.attach();
			return tool;
		}

		function selectLocation(resolve, keydownHandler) {
			const tool = new wpd.LocationSelectionTool(resolve, keydownHandler);
			tool.attach();
			return tool;
		}

		function manualSelection() {
			const tool = new wpd.ManualSelectionTool(axes, dataset);
			wpd.graphicsWidget.setTool(tool);
		}

		function deletePoint() {
			const tool = new wpd.DeleteDataPointTool(axes, dataset);
			wpd.graphicsWidget.setTool(tool);
		}

		function confirmedClearAll() {
			dataset.clearAll();
			wpd.graphicsWidget.removeTool();
			wpd.graphicsWidget.resetData();
			wpd.dataPointCounter.setCount(dataset.getCount());
			wpd.graphicsWidget.removeRepainter();
		}

		function clearAll() {
			if (dataset.getCount() <= 0 && !dataset.hasPointGroups()) {
				return;
			}
			wpd.okCancelPopup.show(
				wpd.gettext("clear-data-points"),
				wpd.gettext("clear-data-points-text"),
				confirmedClearAll,
				function () {},
			);
		}

		function undo() {
			dataset.removeLastPixel();
			wpd.graphicsWidget.resetData();
			wpd.graphicsWidget.forceHandlerRepaint();
			wpd.dataPointCounter.setCount(dataset.getCount());
		}

		function showSidebar() {
			wpd.sidebar.show("acquireDataSidebar");
			wpd.dataPointCounter.setCount(dataset.getCount());
		}

		function adjustPoints() {
			wpd.graphicsWidget.setTool(
				new wpd.AdjustDataPointTool(axes, dataset, false),
			);
		}
		function adjustPositions() {
			wpd.graphicsWidget.setTool(
				new wpd.AdjustDataPointTool(axes, dataset, true),
			);
		}
		function editLabels() {
			// this should only trigger the tool if the axes type is bar
			if (axes instanceof wpd.BarAxes) {
				wpd.graphicsWidget.setTool(new wpd.EditLabelsTool(axes, dataset));
			}
		}

		function switchToolOnKeyPress(alphaKey) {
			if (dataEntryVM.readOnly) {
				return;
			}

			switch (alphaKey) {
				case "d":
					deletePoint();
					break;
				case "a":
					const axisType = wpd.custom.identifyAxis(axes);
					if (["xy", "bar"].includes(axisType)) {
						manualSelection();
					}
					break;
				case "s":
					adjustPoints();
					break;
				case "e":
					editLabels();
					break;
				case "f":
					adjustPositions();
					break;
				default:
					break;
			}
		}

		function isToolSwitchKey(keyCode) {
			if (
				wpd.keyCodes.isAlphabet(keyCode, "a") ||
				wpd.keyCodes.isAlphabet(keyCode, "s") ||
				wpd.keyCodes.isAlphabet(keyCode, "d") ||
				wpd.keyCodes.isAlphabet(keyCode, "e") ||
				wpd.keyCodes.isAlphabet(keyCode, "f")
			) {
				return true;
			}
			return false;
		}

		return {
			load: load,
			manualSelection: manualSelection,
			adjustPoints: adjustPoints,
			adjustPositions: adjustPositions,
			deletePoint: deletePoint,
			selectText: selectText,
			selectLocation: selectLocation,
			clearAll: clearAll,
			undo: undo,
			showSidebar: showSidebar,
			switchToolOnKeyPress: switchToolOnKeyPress,
			isToolSwitchKey: isToolSwitchKey,
			editLabels: editLabels,
		};
	})();
}

export { init };
